import { profileState } from "@/atoms/user/profile-state";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Table, TextInput } from "flowbite-react";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { ordererState } from "../../../atoms/quote/orderer-state";
import { CustomCell } from "../CustomCell";

export const PartnerOrderDetailOrdererTable = () => {
  const headCellStyle = "font-medium text-gray-900 bg-gray-100";
  const [profile, setProfile] = useRecoilState(profileState);
  const [orderer, setOrderer] = useRecoilState(ordererState);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setOrderer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!profile) {
      return;
    }

    setOrderer({
      ordererBusinessName: profile.businessName,
      ordererPhone: profile.phone,
      ordererMail: profile.email,
      ordererName: profile.name,
      constructionName: "",
      constructionWorkName: "",
    });
  }, [profile]);

  return (
    <div className="overflow-x-auto flex flex-col gap-[16px]">
      <div className="rounded-lg border overflow-hidden">
        <Table>
          <Table.Body>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    파트너명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderer.ordererName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    상호명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] h-[52px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderer.ordererBusinessName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    전화번호
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderer.ordererPhone}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    이메일
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderer.ordererMail}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className=" border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    공사명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <TextInput
                  color="white"
                  name="constructionName"
                  placeholder="공사명을 입력해주세요"
                  value={orderer.constructionName}
                  onChange={handleChange}
                />
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    공종명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <TextInput
                  color="white"
                  name="constructionWorkName"
                  placeholder="공종명을 입력해주세요"
                  value={orderer.constructionWorkName}
                  onChange={handleChange}
                />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};
